module.exports = __webpack_public_path__ + "media/41.4b8ceb18.mp3";